import { t } from 'translations'
import { store } from 'store/reducers'

type GetUserName = (
  userId: string,
  options?: {
    firstNameOnly?: boolean
    lastNameOnly?: boolean
    lastNameFirst?: boolean
    employeeNumberOnly?: boolean
    showEmployeeNumber?: boolean
    canBeUnassigned?: boolean
    useLegalName?: boolean
  }
) => string | null

export const getUserName: GetUserName = (
  userId,
  { firstNameOnly, lastNameOnly, lastNameFirst, employeeNumberOnly, showEmployeeNumber, canBeUnassigned, useLegalName } = {}
) => {
  const {
    resources: { usersById },
    settings: { enableLegalName }
  } = store.getState() as MStore.RootState

  if (!userId && !canBeUnassigned) return null
  if (userId === 'Merinio') return 'Merinio'
  if (!usersById[userId] && canBeUnassigned) return t('components.USER_UNASSIGNED')
  else if (!usersById[userId]) return t('components.USER_DELETED')

  const suffix = showEmployeeNumber ? ` (${usersById[userId].employeeNumber || 'N/A'})` : ''
  const shouldUseLegalName = Boolean(useLegalName && enableLegalName)
  const legalName = usersById[userId].legalName

  if (shouldUseLegalName && legalName) return legalName

  // Return only the first or last name
  if (firstNameOnly) return usersById[userId].firstName
  if (lastNameOnly) return usersById[userId].lastName
  if (employeeNumberOnly) return usersById[userId].employeeNumber

  return lastNameFirst
    ? `${usersById[userId].lastName}, ${usersById[userId].firstName}${suffix}`
    : `${usersById[userId].firstName} ${usersById[userId].lastName}${suffix}`
}

type GetUserNames = (userArray: Array<string | Record<string, string>>, options?: { key?: string; delimiter?: string }) => string

export const getUserNames: GetUserNames = (userArray = [], { key = 'userId', delimiter = ' - ' } = {}) => {
  return userArray
    .map(user => {
      // Get the user id
      const userId = typeof user === 'object' ? user[key] : user
      return getUserName(userId)
    })
    .join(delimiter)
}
